// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"0496d96a","404":"a66ae9dd","498":"b791f246","787":"e86098fe"}[chunkId] + ".chunk.js";
};